module.exports = __webpack_public_path__ + "static/img/01.a05e96a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daolan/01.jpg
// module id = le8O
// module chunks = 1